(function() {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('tab-properties', {
            parent: 'entity',
            url: '/tab-properties?page&sort&search',
            data: {
                authorities: ['ROLE_PROPERTY'],
                pageTitle: 'jotApp.tabProperties.home.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/tab-properties/tab-properties.html',
                    controller: 'TabPropertiesController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null,
                predicates : {}
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicates : $stateParams.predicates,
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tabProperties');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('tab-properties-detail', {
            parent: 'entity',
            url: '/tab-properties/{id}',
            data: {
                authorities: ['ROLE_PROPERTY'],
                pageTitle: 'jotApp.tabProperties.detail.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/tab-properties/tab-properties-detail.html',
                    controller: 'TabPropertiesDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tabProperties');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TabProperties', function($stateParams, TabProperties) {
                    return TabProperties.get({id : $stateParams.id});
                }]
            }
        })
        .state('tab-properties.new', {
            parent: 'tab-properties',
            url: '/new',
            data: {
                authorities: ['ROLE_PROPERTY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tab-properties/tab-properties-dialog.html',
                    controller: 'TabPropertiesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                propertyDescription: null,
                                properyValue: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('tab-properties', null, { reload: true });
                }, function() {
                    $state.go('tab-properties');
                });
            }]
        })
        .state('tab-properties.edit', {
            parent: 'tab-properties',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_PROPERTY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tab-properties/tab-properties-dialog.html',
                    controller: 'TabPropertiesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TabProperties', function(TabProperties) {
                            return TabProperties.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('tab-properties', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('tab-properties.delete', {
            parent: 'tab-properties',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_PROPERTY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tab-properties/tab-properties-delete-dialog.html',
                    controller: 'TabPropertiesDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TabProperties', function(TabProperties) {
                            return TabProperties.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('tab-properties', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
